function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClipboard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 37,
  height: 41,
  overflow: "visible",
  preserveAspectRatio: "none",
  viewBox: "0 0 37 41"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4.111 8.2h4.111v6.15h20.556V8.2h4.11v10.25H37V8.2c0-2.255-1.85-4.1-4.111-4.1h-8.592C23.433 1.722 21.172 0 18.5 0s-4.933 1.722-5.797 4.1H4.111C1.85 4.1 0 5.945 0 8.2v28.7C0 39.155 1.85 41 4.111 41H14.39v-4.1H4.11zM18.5 4.1c1.13 0 2.056.923 2.056 2.05S19.63 8.2 18.5 8.2a2.06 2.06 0 0 1-2.056-2.05c0-1.128.925-2.05 2.056-2.05",
  style: {
    strokeWidth: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fill: "#015d59"
  },
  vectorEffect: "non-scaling-stroke"
}));
export default SvgClipboard;